export default __webpack_public_path__ + "static/media/PF.47aff620.svg";